'use client'

import { flushSync } from 'react-dom'

import { useOverlayStore } from '@/features/veluvit/stores/overlay.store'

type PaymentLayerOptions = { signal: AbortSignal; onOpen: () => void }

/** 공급자 레이어가 열려 있는 동안만 기존 시트의 포커스·가림을 양보한다. */
export async function runPaymentLayer<T>(
  signal: AbortSignal,
  open: (options: PaymentLayerOptions) => Promise<T>
): Promise<T> {
  const id = 'payment:' + crypto.randomUUID()
  let opened = false
  const release = () => {
    useOverlayStore.getState().resumeFromExternal(id)
  }
  signal.addEventListener('abort', release, { once: true })
  try {
    if (signal.aborted)
      throw new DOMException('결제가 중단됐어요.', 'AbortError')
    return await open({
      signal,
      onOpen: () => {
        if (signal.aborted)
          throw new DOMException('결제가 중단됐어요.', 'AbortError')
        if (opened) return
        flushSync(() => {
          if (!useOverlayStore.getState().suspendForExternal(id))
            throw new Error('이미 결제창이 열려 있어요.')
          opened = true
        })
      },
    })
  } finally {
    signal.removeEventListener('abort', release)
    release()
  }
}
